module.exports = __webpack_public_path__ + "static/img/txt-6.5f0a55b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zbqfBrand/txt-6.png
// module id = H4cs
// module chunks = 0